import { FC, useRef } from 'react';
import { useClickOutside } from 'react-easyrocket';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { Portal } from 'src/components/Portal/Portal';

interface InfoModalProps {
  closePopup: () => void;
  amountAndCurrency: string;
}

export const InfoModal: FC<InfoModalProps> = ({ closePopup, amountAndCurrency }) => {
  const { t } = useTranslation();
  const infoBlockRef = useRef<HTMLDivElement>(null);

  useClickOutside(infoBlockRef, closePopup);

  return (
    <Portal targetElementId="root">
      <div className="fixed left-0 top-center w-screen h-screen z-[1000] bg-m_shadow">
        <div
          ref={infoBlockRef}
          className="bg-mg_bg z-[3] flex flex-col absolute w-[328px] h-fit rounded-xl px-4 py-5 left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2">
          <h3 className="uppercase mb-2 text-xl text-center text-mg_text_label font-bold">
            {t('depositCryptochill.modalMoreInfoTitle')}
          </h3>
          <div className="overflow-y-auto flex flex-col mb-5 text-mg_text gap-2 text-sm">
            <ol className="list-decimal list-inside pl-4">
              <li>{t('depositCryptochill.infoPopupRuleFirst')}</li>
              <li>{t('depositCryptochill.infoPopupRuleSecond')}</li>
              <li>
                <Trans
                  i18nKey="depositCryptochill.infoPopupRuleThird"
                  components={{
                    1: <span className="p-2" />,
                    2: <br />
                  }}
                  values={{
                    amountAndCurrency
                  }}
                />
              </li>
              <li>{t('depositCryptochill.infoPopupRuleFourth')}</li>
            </ol>
          </div>
          <Button
            title={t('depositCryptochill.okay')}
            onClick={closePopup}
            className="w-full min-w-full">
            {t('depositCryptochill.okay')}
          </Button>
        </div>
      </div>
    </Portal>
  );
};
